import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cookie from 'react-cookies';
import { connect } from 'react-redux';
import { ToastsContainer, ToastsStore } from 'react-toasts';
import Api from '../../util/Api';
import AuthApi from '../../util/AuthApi';
import scss from './profile-user.module.scss';
import { updateProfileImage } from '../../actions/userProfile.action';

let $this;
class ProfileHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userRole: '',
      showDropdown: false
    };
    $this = this;
  }

  componentDidMount = async () => {
    const token = await cookie.load('token');
    if (token) {
      this.getUserData();
    }
    global.document.addEventListener('click', this.handleClick, false)
  }

  handleClick(event) {
    // if (event.target && event.target.className && event.target.className.includes('drpdwnMenu')) return;
    // if (event.target && (!event.target.className || !event.target.className.includes('open-menu'))) $this.setState({ showDropdown: false });
    if (event.target.matches('.drpdwnMenu')) return;
    if (!event.target.matches('.open-menu')) $this.setState({ showDropdown: false });
  }

  componentWillReceiveProps() {
    const { loadProfileImage, updateProfile } = this.props;
    if (loadProfileImage) {
      this.getUserData();
      updateProfile(false);
    }
  }

  componentWillUnmount() {
    global.document.removeEventListener('click', this.handleClick, false)
  }

  getUserData = async () => {
    const endPoint = `${Api.profileUrl}`;
    const { data, messsage } = await AuthApi.getDataFromServer(endPoint);
    if (data) {
      this.setState({ userDetails: data.data });
      cookie.save('skip_payment', data.data.skip_payment, { path: '/' });
    } else {
      await cookie.remove('token');
      window.location.href = window.location.origin + '/login'; //eslint-disable-line
      ToastsStore.error(messsage);
    }
  }

  logOut = async () => {
    const { props } = this.props;
    const confirmMsg = window.confirm('Are you sure you want to log out?');
    if (!confirmMsg) return;
    const { data, message } = await AuthApi.getDataFromServer(`${Api.logoutUrl}`);
    if (data) {
      cookie.remove('token', { path: '/' });
      props.history.push('/login');
    } else {
      ToastsStore.error(message);
    }
  }

  toggleDropdown = () => {
    this.setState({ showDropdown: !this.state.showDropdown });
  }

  render() {
    const {
      userDetails, showDropdown
    } = this.state;
    return (
      <div>
        <div className={scss.profileView}>
          <a className={`${scss[showDropdown ? 'open-menu' : '']} drpdwnMenu`} onClick={this.toggleDropdown}>
            <strong className={`${scss.profileImg} drpdwnMenu`}>
              <img //eslint-disable-line
                src={(userDetails && userDetails.image_url) ? `${Api.IMAGE_URL}/${userDetails.image_url}`
                  : require('../../assets/images/user-profile.jpg')} //eslint-disable-line
                className={`${scss.image} drpdwnMenu`}
              />
            </strong>
            <span className={`${scss.profileText} drpdwnMenu`}>{userDetails && userDetails.first_name}</span>
          </a>
          <ToastsContainer store={ToastsStore} />
          <div className={scss.dropdown}>
            <ul>
              <li><a href="/dashboards/profile">Profile</a></li>
              <li><a href="/changePassword">Change Password</a></li>
              <li><a onClick={this.logOut}>Log Out</a></li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loadProfileImage: state.userProfile.loadProfileImage
});

const mapDispatchToProps = dispatch => ({
  updateProfile: (flag) => {
    dispatch(updateProfileImage(flag));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileHeader);



// WEBPACK FOOTER //
// ./src/components/ProfileUser/ProfileUser.js